export enum PageId {
  INTRO = 'intro',
  ORDER_SELECT = 'order-select',
  INQUIRY_FORM = 'inquiry-form',
}
